export function formatMoneyShort(amount: number, currency: string) {
  if (window.Intl && window.navigator) {
    const formatter = new Intl.NumberFormat(window.navigator.language, {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 1,
    });
    if (amount < 1e3) return `${formatter.format(Math.round(amount))}`;
    if (amount >= 1e3 && amount < 1e6)
      return `${formatter.format(+(amount / 1e3))}K`;
    if (amount >= 1e6 && amount < 1e9)
      return `${formatter.format(+(amount / 1e6))}M`;
    if (amount >= 1e9 && amount < 1e12)
      return `${formatter.format(+(amount / 1e9))}B`;
    if (amount >= 1e12) return `${formatter.format(+(amount / 1e12))}T`;
  }

  if (amount >= 1e3 && amount < 1e6)
    return `${currency}\u00a0${+(amount / 1e3).toFixed(1)}K`;
  if (amount >= 1e6 && amount < 1e9)
    return `${currency}\u00a0${+(amount / 1e6).toFixed(1)}M`;
  if (amount >= 1e9 && amount < 1e12)
    return `${currency}\u00a0${+(amount / 1e9).toFixed(1)}B`;
  if (amount >= 1e12) return `${currency}\u00a0${+(amount / 1e12).toFixed(1)}T`;

  return `${currency}\u00a0${amount.toFixed()}`;
}

export function formatMoney(amount: number, currency: string, short = false) {
  const limitedAmount = amount < 0 ? 0 : amount;

  if (limitedAmount === 0 && window.CANDYRACK_FREE_PRODUCT_PRICE_TEXT) {
    return window.CANDYRACK_FREE_PRODUCT_PRICE_TEXT;
  }

  if (short) {
    return formatMoneyShort(limitedAmount, currency);
  }

  if (window.CANDYRACK_CUSTOM_FORMAT_MONEY) {
    return window.CANDYRACK_CUSTOM_FORMAT_MONEY(amount, currency);
  }

  if (window.CANDYCART_CUSTOM_FORMAT_MONEY) {
    return window.CANDYCART_CUSTOM_FORMAT_MONEY(amount, currency);
  }

  if (window.Intl && window.navigator) {
    return new Intl.NumberFormat(window.navigator.language, {
      style: 'currency',
      currency,
    }).format(limitedAmount);
  }

  return `${limitedAmount} ${currency}`;
}
